import classnames from 'classnames';

import styles from './CardItem.module.scss';
import { CardItemProps } from './CardItem.types';

const CardItem = ({
  leading,
  title,
  subtitle,
  trailing,
  onClick,
  emphasizeTrailing,
}: CardItemProps) => (
  <div
    className={classnames(styles.item, onClick && styles.clickable)}
    onClick={onClick}
    role={onClick ? 'button' : undefined}
    tabIndex={onClick ? 0 : undefined}
    onKeyDown={
      onClick
        ? event => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              onClick();
            }
          }
        : undefined
    }
  >
    {leading !== undefined && <div className={styles.leading}>{leading}</div>}
    <div className={styles.body}>
      <span className={styles.title}>{title}</span>
      {subtitle !== undefined && <span className={styles.subtitle}>{subtitle}</span>}
    </div>
    {trailing !== undefined && (
      <span className={classnames(styles.trailing, emphasizeTrailing && styles.trailingEmphasized)}>
        {trailing}
      </span>
    )}
  </div>
);

export default CardItem;
